//Check if token is valid + refresh token expire time

async function CheckToken(userid, token) {

    if (userid != null && token != null) {

        let response;

        response = await fetch("https://api.cssi.co/login/checktoken", {
            method: "POST",
            body: JSON.stringify(
                {
                    "userId": userid,
                    "token": token
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default CheckToken;